import { Switch, Route, useRouteMatch } from 'react-router-dom';

import SuperAdminUserContainer from '@pages/superAdminUsers/superAdminUser/SuperAdminUserContainer';
import SuperAdminUsers from '@pages/superAdminUsers/superAdminUsers/SuperAdminUsers';

const AdminUsersRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <SuperAdminUsers />
            </Route>
            <Route exact path={`${path}/create`}>
                <SuperAdminUsers showCreateModal />
            </Route>
            <Route exact path={`${path}/:id`}>
                <SuperAdminUserContainer />
            </Route>
            <Route exact path={`${path}/:id/:action`}>
                <SuperAdminUserContainer />
            </Route>
        </Switch>
    );
};

export default AdminUsersRoutes;
